import { createFeatureSelector } from '@ngrx/store';

import {
  ContainerIdentifierWithIndex,
  CutOrCopy,
  EntryIdentifier,
} from './container-edit.actions';

export type ClipboardState = {
  cutOrCopy: CutOrCopy;
  entry: EntryIdentifier;
  from: ContainerIdentifierWithIndex;
} | null;

export const STATE_FEATURE_CLIPBOARD_SOURCE = 'clipboardSource';

export const CLIPBOARD_SOURCE_INITIAL_STATE: ClipboardState = null;

export const selectClipboardSource = createFeatureSelector<ClipboardState>(
  STATE_FEATURE_CLIPBOARD_SOURCE,
);

export function getInitialClipboardSourceState(): ClipboardState {
  return CLIPBOARD_SOURCE_INITIAL_STATE;
}
